import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Select, { SingleValue } from 'react-select';
import { Col, Row } from 'reactstrap';
import SimpleBar from 'simplebar-react';
import { EmployeeModel } from '../../../domain/projects/project';
import { BaseSelector } from '../../../domain/shared';
import { EmployeeListSelectorDTO } from '../../../infrastructure/http/dtos/employees/employeeListSelectorDTO';
import { EmployeesRepository } from '../../../infrastructure/repositories/employees/employeeRepository';

interface Props {
    onChange: (selectedEmployees: EmployeeModel[]) => void;
    value: EmployeeModel[];
    name: string;
}

export const EmployeeAddList = ({ onChange, value, name }: Props) => {
    const [employees, setEmployees] = useState<BaseSelector[]>([]);
    const [employeesCopy, setEmployeesCopy] = useState<EmployeeListSelectorDTO[]>(
        []
    );
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        setIsLoading(true);

        EmployeesRepository.GetEmployeesListSelector().then((res) => {
            setEmployeesCopy(res);

            setIsLoading(false);
            setEmployees(
                res.map((c) => ({
                    label: `${c.firstName} ${c.middleName} ${c.lastName} ${c.surname}`,
                    value: c.id,
                }))
            );
        });
    }, []);

    const handlerChange = (e: SingleValue<BaseSelector>) => {
        let employee = employeesCopy.find((emp) => emp.id === e?.value);
        let existEmployee = value.filter((emp) => emp.id === Number(e?.value));

        if (existEmployee.length === 0) {
            if (e && e.value !== '') {
                const newEmployee: EmployeeModel = {
                    fullName: `${employee?.firstName} ${employee?.middleName} ${employee?.lastName} ${employee?.surname}`,
                    position: employee?.position ?? '',
                    email: employee?.email ?? '',
                    id: Number(e?.value) ?? 0,
                };

                onChange([...value, newEmployee]);
            }
        }
    };

    const handlerRemove = (em: EmployeeModel) => {
        let employeesFilterdList = value.filter((c) => c.id != Number(em?.id));

        onChange(employeesFilterdList);
    };

    return (
        <div className='mt-2 '>
            <div>
                <label htmlFor={name} className='form-label form-label'>
                    Responsables *
                </label>
                <Select
                    className='basic-single'
                    classNamePrefix='select'
                    isLoading={isLoading}
                    isSearchable
                    placeholder='Seleccione'
                    name='color'
                    options={employees}
                    onChange={(c) => handlerChange(c)}
                    isClearable
                    id={name}
                />
            </div>
            {value.length > 0 && (
                <SimpleBar
                    style={{
                        maxHeight: '352px',
                        height: '250px',
                        backgroundColor: '#fff',
                    }}
                    className='py-3 mt-2'
                >
                    <div>
                        {value.length > 0 &&
                            value.map((e, i) => (
                                <Row key={i} className='g-2 p-1'>
                                    <Col xxl={12} lg={6}>
                                        <div className='border rounded border-dashed p-1'>
                                            <div className='d-flex align-items-center'>
                                                <div className='flex-shrink-0 me-3'>
                                                    <div
                                                        key={i}
                                                        className='avatar-sm'
                                                    >
                                                        <div className='avatar-title bg-light text-primary rounded fs-24'>
                                                            <i className='ri-map-pin-user-line'></i>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='flex-grow-1 overflow-hidden'>
                                                    <h5 className='fs-13 mb-0'>
                                                        <Link
                                                            to='#'
                                                            className='text-body text-truncate d-block'
                                                        >
                                                            <li key={i}>
                                                                {e.fullName}
                                                            </li>
                                                        </Link>
                                                    </h5>
                                                    <div className='text-muted'>
                                                        {e.position} - {'   '}
                                                        {e.email}
                                                    </div>
                                                </div>
                                                <div className='flex-shrink-0 ms-2'>
                                                    <div className='d-flex gap-1'>
                                                        <button
                                                            onClick={() =>
                                                                handlerRemove(e)
                                                            }
                                                            type='button'
                                                            className='btn btn-icon text-muted btn-sm fs-18'
                                                        >
                                                            <i className='ri-close-line'></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            ))}

                        {value.length === 0 && <p>No hay contactos agregados...</p>}
                    </div>
                </SimpleBar>
            )}
        </div>
    );
};
